import React from "react";
import { Link, useLocation } from "react-router-dom";
import { CaretRight, House } from "@phosphor-icons/react";
import { resolveActive } from "../../config/workspaces";

/**
 * Breadcrumbs — home › workspace › page. Rendered by AdminShell above
 * every admin page for orientation. Uses the workspace config so labels
 * and hierarchy stay in sync with the sidebar and tab bar.
 */

export default function Breadcrumbs() {
  const location = useLocation();
  const { workspace, item } = resolveActive(location.pathname);

  if (!workspace) return null;

  const crumbs = [
    { label: "Home", to: "/admin", icon: House },
  ];
  if (workspace.id !== "home") {
    crumbs.push({ label: workspace.label, to: workspace.items[0]?.to || "/admin" });
  }
  if (item) {
    crumbs.push({ label: item.label, to: item.to, current: true });
  }

  return (
    <nav
      aria-label="Breadcrumb"
      className="hidden lg:flex items-center gap-1.5 text-[11px] text-neutral-500 px-4 lg:px-6 pt-2"
      data-testid="breadcrumbs"
    >
      {crumbs.map((c, i) => {
        const Icon = c.icon;
        return (
          <React.Fragment key={`${c.to}-${i}`}>
            {i > 0 && <CaretRight size={9} weight="bold" className="text-neutral-700" />}
            {c.current ? (
              <span className="text-neutral-200 font-medium" data-testid="breadcrumb-current">
                {c.label}
              </span>
            ) : (
              <Link to={c.to} className="hover:text-white transition-colors inline-flex items-center gap-1">
                {Icon && <Icon size={11} weight="bold" />}
                {c.label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
